<template>
    <v-app class="bg-application">

        <main-menu :nav-toggle="navToggle"></main-menu>

        <v-app-bar dense app>
            <v-app-bar-nav-icon @click="navToggle = !navToggle"></v-app-bar-nav-icon>

            <breadcrumbs></breadcrumbs>

            <v-spacer></v-spacer>

            <locale-select></locale-select>
            <v-btn icon :title="$t('layouts.main_layout.store_data')" :to="{name:'profile'}">
                <v-icon class="primary--text">mdi-domain</v-icon>
            </v-btn>
            <v-btn icon @click="logout" :title="$t('layouts.main_layout.logout')" :loading="loggingOut">
                <v-icon class="primary--text">mdi-power-standby</v-icon>
            </v-btn>

        </v-app-bar>
        <v-main>
            <v-container fluid>
                <v-fade-transition mode="out-in">
                    <router-view :key="$route.fullPath"></router-view>
                </v-fade-transition>
            </v-container>
        </v-main>
        <snackbar></snackbar>
        <v-footer app class="pa-0 flex-column align-stretch" v-if="showFooter" ref="footer">
            <v-alert
                v-for="(message, index) in messages"
                v-model="messages[index].show"
                :key="'message-'+index"
                :type="messageType(message.Type)"
                tile
                dismissible
                :class="{'ma-0': true, 'py-2': true, 'black--text': (message.Type === 2)}"
            >
                {{message.Content}}
            </v-alert>
        </v-footer>
    </v-app>
</template>

<script>
    import MainMenu from "./components/MainMenu";
    import Breadcrumbs from "./components/Breadcrumbs";
    import Snackbar from "./components/Snackbar";
    import {Auth} from "../modules/utils";
    import LocaleSelect from "./components/LocaleSelect";

    export default {
        name: "MainLayout",

        components: {
            MainMenu,
            Breadcrumbs,
            Snackbar,
            LocaleSelect,
        },

        data: () => ({
            navToggle: true,
            loggingOut: false,
            messages: [],
        }),

        computed: {
            showFooter: function () {
                return this.messages.some(message => message.show);
            },
        },

        methods: {
            logout: function () {
                if(this.loggingOut) {
                    return;
                }

                this.loggingOut = true;

                this.$store.dispatch('logout')
                    .then(response => {
                        if(response.status !== 204) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('layouts.main_layout.logout_failed')
                            );
                            return;
                        }
                        Auth.clear();
                        Auth.redirectToLogin();
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loggingOut = false;
                    });
            },
            activeMessageIndex: function () {
                this.$store.dispatch('activeMessageIndex').then(response => {
                    this.messages = response.data.data.map(message => ({...message, show: true}));
                }).catch(() => {});
            },

            messageType: function (id) {
                switch (id) {
                    case 1:
                        return "error";
                    case 2:
                        return "warning";
                    default:
                        return "info";
                }
            },
        },

        created () {
            this.activeMessageIndex();
        },
        watch: {
            messages: {
                handler: function () { 
                    this.$nextTick(() => {
                        this.$store.commit(
                            'setFooterHeight', 
                            this.showFooter 
                                ? this.$refs.footer.$el.offsetHeight 
                                : 0
                        );
                    });
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>
